import { Div } from "@tblabs/truffle";


export class Hero extends Div
{
    constructor()
    {
        super("hero-content");

        this.Html(`
            <div class="hero__content">
                <div class="hero__text">
                    <h1 class="hero__title">Wypożyczalnia Sprzętu Detektywistycznego</h1>
                    <p class="hero__subtitle">Sprzęt, który zdaje egzamin!</p>
                    <div class="hero__buttons">
                        <a href="#kategorie-produktow" class="button primary">Zobacz nasz sprzęt</a>
                        <a href="#kontakt" class="button secondary">Skontaktuj się z nami</a>
                    </div>
                </div>
            </div>
            <div class="hero__features">
                <div class="hero__features-root">
                    <div class="hero__features-background" aria-hidden="true"></div>
                    <div class="hero__features-grid">
                        <a href="#blog/nasze-zasady" class="hero__features-row">
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-handshake hero__feature-icon">
                                            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                                            <path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"></path>
                                            <path d="m18 15-2-2"></path>
                                            <path d="m15 18-2-2"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">BEZ UMOWY<br>BEZ DOKUMENTÓW</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield hero__feature-icon">
                                            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">UBEZPIECZENIE<br>OD USZKODZEŃ</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone hero__feature-icon">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">WSPARCIE SPECJALISTÓW</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck hero__feature-icon">
                                            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                                            <path d="M15 18H9"></path>
                                            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                                            <circle cx="17" cy="18" r="2"></circle>
                                            <circle cx="7" cy="18" r="2"></circle>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">PRZESYŁKA<br>W 24H</h3>
                                </div>
                            </div>
                            <div class="hero__feature group" tabindex="0">
                                <div class="hero__feature-inner">
                                    <div class="hero__feature-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock hero__feature-icon">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                        </svg>
                                    </div>
                                    <h3 class="hero__feature-title">MINIMUM 3 DNI<br>W CENIE</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `);
    }
}
